<template>
  <div class="alipy">
    <Title text="支付订单" />
    <div class="product">
      <div style="text-align:center">
        <div class="success-icon">
          <img src="../assets/images/order/order_img_zhifucg@2x.png" alt />
        </div>
        <span>订单提交成功！请尽快支付您的订单</span>
      </div>
      <ul>
        <li>
          <span>订单号:</span>
          <span>{{order.sno}}</span>
        </li>
        <li>
          <span>应付金额：</span>
          <span style="color:#ff9900">￥{{order.totalAmount | moneyFilter}}</span>
        </li>
        <li>
          <span>下单时间：</span>
          <span>{{order.createdTime}}</span>
        </li>
      </ul>
    </div>
    <!-- 支付方式 -->
    <div class="chosse-payment">
      <ul>
        <li v-for="(item,index) in paymentList" :key="index" @click="paymentChoose(item,index)">
          <div class="type-icon">
            <img :src="item.img" alt />
          </div>
          <span>{{item.text}}</span>
          <div class="radio-icon">
            <img src="../assets/images/order/xuanzeh@2x.png" alt v-show="current == index" />
          </div>
        </li>
      </ul>
    </div>
    <!-- 底部 -->
    <div
      class="footer"
      @click="payment"
    >{{current == 0 ? '微信支付' : '支付宝支付'}}￥{{order.totalAmount | moneyFilter}}</div>
  </div>
</template>

<script>
import Title from "../components/Title";
import { OutlineOrder, WXpay, Alipay } from "../request/api";
import { toMoney } from "../common/moneyFilter";
export default {
  data() {
    return {
      current: 0,
      order: {},
      paymentList: [
        {
          img: require("../assets/images/order/weixinzf@2x.png"),
          text: "微信"
        },
        {
          img: require("../assets/images/order/umidd17@2x.png"),
          text: "支付宝"
        }
      ]
    };
  },
  filters: {
    moneyFilter(money) {
      return toMoney(money);
    }
  },
  created() {
    this.getPayDetail();
  },
  components: {
    Title
  },
  methods: {
    //选择支付类型
    paymentChoose(item, index) {
      this.current = index;
    },
    //查询订单信息
    getPayDetail() {
      let sno = this.$route.query.sno;
      OutlineOrder(sno).then(res => {
        this.order = res.data;
      });
    },
    //支付
    payment() {
      if (this.current == 0) {
        //微信支付
        WXpay(this.order.sno).then(res => {
          if (res.status == 200) {
            window.location.replace(res.data.mwebUrl);
          }
        });
      } else {
        //支付宝支付
        Alipay(this.order.sno).then(res => {
          console.log(res);
          if (res.status == 200) {
            const div = document.createElement("div");
            div.innerHTML = res.data;
            document.body.appendChild(div);
            document.forms[0].submit();
          }
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.alipy {
  width: 100%;
  height: 100%;
  background: #f5f5f5;
}
.product {
  padding: 35px 30px;
  margin-bottom: 20px;
  background: #fff;
  ul {
    margin-top: 80px;
    li {
      line-height: 45px;
      font-size: 28px;
      span:nth-child(2) {
        float: right;
      }
    }
  }
  .success-icon {
    width: 30px;
    height: 30px;
    vertical-align: middle;
    margin-right: 10px;
    display: inline-block;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
// 支付方式
.chosse-payment {
  margin: 20px 0 120px 0;
  background: #fff;
  font-size: 28px;
  padding: 0 30px;

  ul {
    li {
      width: 100%;
      height: 98px;
      line-height: 98px;
    }
    li:not(:last-child) {
      border-bottom: 1px solid #f2f2f2;
    }
  }
  .type-icon {
    width: 40px;
    height: 40px;
    margin-right: 30px;
    float: left;
    margin-top: 12px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .radio-icon {
    width: 60px;
    height: 60px;
    float: right;
    margin-top: 20px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.footer {
  width: 100%;
  height: 106px;
  background: #ff6600;
  color: #fff;
  font-size: 32px;
  text-align: center;
  position: fixed;
  bottom: 0;
  line-height: 106px;
}
</style>